/** 세부지명 요청 모델의 주소 부분 모델 */
export default class RequestMapAddress {
    /** 시도 */
    siDo = '';
    /** 시군구 */
    siGunGu = '';
    /** 세부명칭 (신주소의 건물명이 세부명칭과 같은 것이다.) */
    buildingName = '';
    /** 상세주소 (안쓰임) */
    detail = '';
    /** 행정동(특수지명) */
    administrativeArea = '';
    /** 구주소 (지번) */
    lotNumber = {
        dong: '',
        ri: '',
        /** 주번 */
        mainNumber: '',
        /** 부번 */
        subNumber: '',
    };
    /** 신주소 (행정동) */
    roadName = {
        name: '',
        mainBuildingNumber: '',
        subBuildingNumber: '',
    };
    /** 위치 */
    location = {
        /** 위도 높낮이, 북극 남극 */
        latitude: '',
        /** 경도 좌우, 동쪽, 서쪽 */
        longitude: '',
    };
    constructor(_data) {
        if (!_data) {
            return;
        }
        const data = this.translate(_data);
        Object.assign(this, data);
    }
    /**
     * 서버 응답값을 프론트에서 사용할 형태로 번역
     * back -> front
     * @returns
     */
    // eslint-disable-next-line class-methods-use-this
    translate(data) {
        return {
            ...data,
        };
    }
    /**
     * 전체 주소를 반환 [지번 주소, 도로명 주소]
     * @param type 주소 타입
     */
    getFullAddress(type = 'LOT_NUMBER') {
        if (type === 'LOT_NUMBER') {
            const addr = this;
            let addrStr = '';
            addrStr += `${addr.siDo} ${addr.siGunGu}`;
            if (addr.lotNumber.dong) {
                addrStr += ` ${addr.lotNumber.dong}`;
            }
            if (addr.lotNumber.ri) {
                addrStr += ` ${addr.lotNumber.ri}`;
            }
            addrStr += ` ${addr.lotNumber.mainNumber}`;
            if (addr.lotNumber.subNumber) {
                addrStr += `-${addr.lotNumber.subNumber}`;
            }
            if (addr.buildingName) {
                addrStr += ` ${addr.buildingName}`;
            }
            if (addr.administrativeArea) {
                addrStr += ` (${addr.administrativeArea})`;
            }
            return addrStr;
        }
        if (type === 'ROAD_NAME') {
            const addr = this;
            let addrStr = '';
            addrStr += `${addr.siDo} ${addr.siGunGu}`;
            if (addr.roadName.name) {
                addrStr += ` ${addr.roadName.name}`;
            }
            if (addr.roadName.mainBuildingNumber) {
                addrStr += ` ${addr.roadName.mainBuildingNumber}`;
            }
            if (addr.roadName.subBuildingNumber) {
                addrStr += `-${addr.roadName.subBuildingNumber}`;
            }
            if (addr.buildingName) {
                addrStr += ` ${addr.buildingName}`;
            }
            if (addr.administrativeArea) {
                addrStr += ` (${addr.administrativeArea})`;
            }
            return addrStr;
        }
        return '';
    }
}
